<section *ngIf="variablesService.social" class="footer-wrapper">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 col-sm-4 col-md-4 col-lg-4 twitter">
        <span class="follow-txt">
          <!-- <a rel="noopener" target="_blank" href="https://www.linkedin.com/company/ketto-online-ventures-private-limited" aria-label="linkedin"><i class="icon-linkedin"></i></a> -->
          <!-- <a rel="noopener" target="_blank" href="https://www.youtube.com/@Kettoindia" aria-label="youtube"><i class="icon-youtube1"></i></a> -->
          <!-- <a rel="noopener" target="_blank" href="https://www.instagram.com/kettoindia/" aria-label="instagram"><i class="icon-instagram1"></i></a> -->
          <!-- <a rel="noopener" (click)="whatsappChat()" href="javascript:void(0)" aria-label="whatsapp"><i class="icon-whatsapp"></i></a> -->
          <a rel="noopener" href="http://www.twitter.com/ketto" target="_blank"><i class="icon-twitter"></i></a>
          <a rel="noopener" href="https://www.facebook.com/profile.php?id=100064806753864" target="_blank"><i class="icon-fb"></i></a>{{'Stories.follow' | translatePipe | async}}
        </span>
      </div>
      <div class="col-12 col-sm-4 col-md-4 col-lg-4 facebook">
        <span class="follow-txt">
            <a rel="noopener" href="https://www.facebook.com/profile.php?id=100064806753864" target="_blank"><i class="icon-thumbsup"></i></a>{{'Stories.like' | translatePipe | async}}
        </span>
      </div>
      <div *ngIf="!isSipSubscribed" class="col-12 col-sm-4 col-md-4 col-lg-4 download-app">
        <app-download-app-banner [config]="{v: 3, title: 'Download the Ketto app now!', info_1: 'footer'}"></app-download-app-banner>
      </div>
      <div class="col-12 {{!isSipSubscribed ? 'internal-tc-v2' : 'col-sm-4 col-md-4 col-lg-4'}} links internal-tc">
        <div class="logo" data-bg="/assets/images/logo-light-bg.svg"></div>
        <div class="policies">
          <span>
            <a rel="noopener" href="https://customerhappiness.ketto.org/portal/en/kb/articles/terms-of-use-7-8-2021-1" target="_blank">{{'Stories.termsofuse' | translatePipe | async}}</a> | 
            <a rel="noopener" href="https://customerhappiness.ketto.org/portal/en/kb/articles/privacy-policy-7-8-2021" target="_blank">{{'Stories.donations.privacyPolicy' | translatePipe | async}}</a> | 
            <a rel="noopener" href="/support/use-of-cookies.php" target="_blank">{{'Stories.useofcookies' | translatePipe | async}}</a> | 
            <a rel="noopener" href="https://customerhappiness.ketto.org/portal/en/kb/articles/trust-safety-7-8-2021" target="_blank">{{'Stories.trustandsafety' | translatePipe | async}}</a>
          </span>
          <span>{{currentYear}} | {{'Stories.allrights' | translatePipe | async}}</span>
      </div>
      </div>
    </div>
  </div>
</section>